import React from 'react'

import { Route, Routes } from 'react-router-dom'

import PropTypes from 'prop-types'

import ContextBasedRouter from 'Pods/Shared/ContextBasedRouter'

import AboutUs from './AboutUs'

function AboutUsWrapper({
  navigation,
  modelsCount,
  designersCount,
}) {
  return (
    <ContextBasedRouter initialPathname={navigation.currentPathname}>
      <Routes>
        <Route
          path="/about-us"
          element={(
            <AboutUs
              modelsCount={modelsCount}
              designersCount={designersCount}
            />
          )}
        />
      </Routes>
    </ContextBasedRouter>
  )
}

AboutUsWrapper.propTypes = {
  modelsCount: PropTypes.number.isRequired,
  designersCount: PropTypes.number.isRequired,
  navigation: PropTypes.shape({
    currentPathname: PropTypes.string.isRequired,
  }).isRequired,
}

export default AboutUsWrapper
